import React, { useState, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import unread from "../../../assets/images/unread.png"
import { convertTimestamp } from '../../../utils'
import { useNavigate } from 'react-router'
import { modifyHtmlForNavigation, useNotificationNavigation } from '../../../utils';
import { useSelector } from 'react-redux';
import { appTheme, retrieveData } from '../../../helpers/utils/Utils';
import { useDispatch } from "react-redux";
import { useEffect } from 'react'


const NotificationItem = ({ notification, selectedTab, onAction }) => {
    const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
    const appThemeData = appTheme(kudzuPlusTrue);
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [isRead, setIsRead] = useState(false);
    const { Content, CreatedDateTime, AlertTypeCode, Unread, ID } = notification;
    const timeStamp = convertTimestamp(CreatedDateTime);
    const modifiedContent = modifyHtmlForNavigation(notification.Content, 'var(--notificationUnreadTest)', notification.Unread);
    const notificationNavigation = useNotificationNavigation();
    const dispatch = useDispatch();
    const effectiveBrand = useMemo(() => {
        if (notification?.ProgramKey === 112) {
            return 'smiONE';
        }
        return 'Kudzu';
    }, [notification]);
   const accessToken = useSelector(state => state.accessToken);

    const applyDynamicStyles = () => {
        // Target any element with "notification-title" class
        const notificationTitleElements = document.querySelectorAll(".notification-title");
     
        if (notificationTitleElements.length > 0) {
          notificationTitleElements.forEach((el) => {
            // el.style.color = "var(--notificationtextheadingsColor)";
            el.style.fontSize = "26px";
            el.style.fontWeight = "600";
            el.style.marginBottom = "8px";
            el.style.lineHeight = "1.5";
            el.style.fontFamily = "'Hanken Grotesk', sans-serif";
          });
        }

        const notificationText = document.querySelectorAll(".notification-text");
     
        if (notificationText.length > 0) {
          notificationText.forEach((el) => {
            // el.style.color = "var(--notificationtextheadingsColor)";
            el.style.marginBottom = "40px";
           
          });
        }

        const notificationFootNote = document.querySelectorAll(".notification-footnote");
      
        if (notificationFootNote.length > 0) {
          notificationFootNote.forEach((el) => {
            // el.style.color = "var(--notificationtextheadingsColor)";
            el.style.fontSize = "14px";
           
          });
        }

            const notificationLink = document.querySelectorAll(".notification-link");
          
            if (notificationLink.length > 0) {
              notificationLink.forEach((el) => {
                // el.style.color = "var(--notificationtextheadingsColor)";
               el.style.textDecoration = "underline";
               
              });
            }

      const notificationButtons = document.querySelectorAll(".notification-button");
      if (notificationButtons.length > 0) {
        notificationButtons.forEach((btn) => {
          btn.style.backgroundColor = "#2a52be";
          btn.style.color = "#ffffff";
          btn.style.border = "none";
          btn.style.padding = "10px 16px";
          btn.style.borderRadius = "4px";
          btn.style.cursor = "pointer";
        });
      }

    };


    useEffect(() => {
        // Apply styles after component mounts and content is rendered
        applyDynamicStyles();
    }, [modifiedContent]);




    const handleItemClick = () => { 
        navigate(`/notifications/${ID}`)
    }


    return (
        <>
            <div className=' flex flex-col' key={ID}>
                <div className=' flex flex-col mt-10 gap-3 cursor-pointer' onClick={handleItemClick}>
                    <div className=' flex flex-row gap-4'>
                        {Unread ?
                            <div className='pt-2'>
                                <img src={notification.Content.includes('Covered') ? appThemeData.sideBarDotForCbk : appThemeData.unread} className=' h-[10px] w-[10px]' alt="dot" />
                            </div>
                            :
                            <div className='pt-2 w-[10px]'></div>
                        }
                        <div className=' flex flex-col w-[80%] '>
                            <div className=' flex flex-col gap-5 w-[80%] mb-10'>
                                <div className={`font-hanken-grotesk font-[600] md:text-[18px] md:leading-[27px] sm:text-[12px] sm:leading-[20px] text-[13px] leading-[19px] text-[var(--notificationText)] ${!notification.Unread ? 'text-[var(--notificationText-Disable)]' : 'text-[var(--notificationText)]'}`}>

                                    <div
                                        dangerouslySetInnerHTML={{ __html: modifiedContent }}
                                        onClick={(e) => {
                                            if (e.target.tagName === 'A') {
                                                 e.preventDefault();
                                                e.stopPropagation();
                                                const href = e.target.getAttribute('href');
                                                dispatch({
                                                     type: 'CBK_TRANSACTIONS',
                                                    payload: {
                                                      notifications: [{ ...notification }]
                                                    }
                                                  });
                                              if (href && (href.startsWith('http://') || href.startsWith('https://'))) {
                                                window.open(href, '_blank', 'noopener,noreferrer');
                                              } else if (href && (href === "yes-replace" || href === 'no-replace' || href === 'yes-unblock' || href === 'no-unblock')) {
                                                let action = null;
                                                if (href === "yes-replace") {
                                                  action = notification.YesAction;
                                                } else if (href === 'no-replace') {
                                                  action = notification.NoAction;
                                                } else if (href === 'yes-unblock') {
                                                  action = notification.YesAction;
                                                }
                                                else if (href === 'no-unblock') {
                                                  action = notification.NoAction;
                                                }

                                                if (action && action.CallbackURL) {
                                                  if (onAction) {
                                                    onAction(action.CallbackURL);
                                                  }
                                                }
                                              }
                                              else {

                                                notificationNavigation(href, e);
                                              }
                                            }

                                        }}
                                    />
                                </div>
                                <div className=' flex flex-row gap-2'>
                                    {AlertTypeCode === "WRN" &&
                                        <div className=' bg-footer rounded-full py-1 px-3'>
                                            <p className='font-hanken-grotesk font-[700] text-[9px] leading-[15px] md:text-[12px] md:leading-[18px] text-white'>
                                                {t("important")}
                                            </p>
                                        </div>
                                    }
                                    {selectedTab === 'All' && effectiveBrand && (
                                        <div
                                          className={`rounded-full px-4 py-[4px] flex items-center justify-center
                                          ${effectiveBrand === 'smiONE' ? 'bg-[#4B70B9]' : 'bg-[#559C7E]'}
                                          `}
                                        >
                                          <span className="font-hanken-grotesk text-white font-[700] text-[12px] sm:font-[600]  sm:text-[10px] sm:leading-[15px] md:text-[14px] md:leading-[14px]">
                                            {effectiveBrand === 'smiONE' ? 'smiONE' : 'Kudzu'}
                                          </span>
                                        </div>
                                      )}
                                    <p className='font-hanken-grotesk font-[500] text-[12px] sm:font-[600]  sm:text-[10px] sm:leading-[15px] md:text-[14px] md:leading-[14px]  text-[var(--timeStampText)] opacity-50'>
                                        {timeStamp}
                                    </p>

                                </div>
                            </div>
                            <hr className=" h-[2.5px]  bg-blue-sky border-0 rounded" />

                        </div>

                    </div>

                </div>
                {/* <hr className=" h-[2.5px]  bg-blue-sky border-0 rounded" /> */}

            </div>

        </>
    )
}

export default NotificationItem